// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__VxUWs","rowLegend":"rowLegend__SpxpN","innerLegend":"innerLegend__z4X7a","row":"row__9n5Tw","rowWrapper":"rowWrapper__2YNrf","rowWrapperItem":"rowWrapperItem__1gpDp","rowText":"rowText__1w2WS","country_percentage":"country_percentage__2MiBk","countryWrapper":"countryWrapper__1oO6f","allDonorWrapper":"allDonorWrapper__XRXPF","labelText":"labelText__59YpP","barValue":"barValue__14w3t","text":"text__2vFqw","barType":"barType__21Pf5","imageWrapper":"imageWrapper__3angW","sdg_image":"sdg_image__n1VCH"};


//////////////////
// WEBPACK FOOTER
// ./components/donutBarChart/components/barChartItem/style.scss
// module id = yuEP
// module chunks = 22